module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "backTop-demo",
    attrs: {
      "title": "BackTop"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    }
  }, [_c('p', [_vm._v("向下滚动300px，即可显示默认的BackTop组件")]), _vm._v(" "), _c('BackTop')], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.rocket_code
    }
  }, [_c('p', [_vm._v("向下滚动100px，即可自定义配置的BackTop组件")]), _vm._v(" "), _c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 100
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.rocket,
      "width": "50",
      "height": "50",
      "alt": "backTop"
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fd6ab4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/BackTop.vue
// module id = 629
// module chunks = 0